import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import classnames from 'classnames';
import React, { useEffect, useState, useContext } from 'react';
import { AppContext } from '../../AppContext';
import cloneDeep from 'lodash.clonedeep';
import { OrderReviewContext } from '../QaOrderReview/OrderReviewContext';
import FormInput from '../ReactHookForm/FormInput/FormInput';

// SERVICES
import { getOrderableFormHeaders, addFormHeader } from '../../services';
import { Autocomplete } from '../Autocomplete';
import ReactSelect from 'react-select';

const styles = theme => ({
  container: {
    flex: 1,
    backgroundColor: 'white',
    padding: 20,
    minHeight: 100,
    overflowY: 'visible',
    '& > *': {
      alignSelf: 'stretch',
    },
  },
  supplementDialogContent: {
    overflowY: 'visible',
    position: 'relative',
  },
  dialogTitle: {
    backgroundColor: '#fafafa',
    borderBottom: '1px solid #e1e1e1',
  },
  dialogActions: {
    backgroundColor: '#fafafa',
    borderBottom: '1px solid #e1e1e1',
  },
  cancelButton: {
    color: '#f44336',
  },
  removeButton: {
    color: '#f44336',
  },
  circularProgress: {
    padding: '6px 8px',
  },
  fileLink: {
    display: 'flex',
    flexDirection: 'row',
  },
  uploadButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  errorMessage: { color: '#c33' },

  supplementTable: {
    width: '100%',

    '& td': {
      flex: 1,
      textAlign: 'left',
    },

    '& tr': {
      marginBottom: 10,
    },

    '& th': {
      textAlign: 'center',
      fontWeight: 'bold',
    },

    '& > tr > *': {
      padding: 20,
    },
  },

  tableInput: {
    border: '1px solid #ccc',
    borderRadius: 5,
    padding: 10,
    fontSize: 16,
    color: '#777',

    '&:focus': {
      outline: 'none',
    },
  },
});

export const ReportSupplementForms = withStyles(styles)(
  ({ classes, orderLineId, setOrder: updateOrder, order: initialOrderState, onClose }) => {
    // #region STATE
    const [dialogOpen, setDialogOpen] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState([]);
    const [order, setOrder] = useState(cloneDeep(initialOrderState));
    const [selectedOFH, setSelectedOFH] = useState();
    const [numberOfSupplementsToAdd, setNumberSupplementsToAdd] = useState(1);
    // #endregion

    // #region HOOKS
    const { state, dispatch: orderReviewDispatch, actions } = useContext(OrderReviewContext);
    const { dispatch } = useContext(AppContext);
    // #endregion

    // #region COMPUTER
    const { orderableFormHeaders } = state;
    // #endregion

    useEffect(() => {
      setOrder(
        cloneDeep({
          ...initialOrderState,
        }),
      );
    }, [dialogOpen]);

    const addSupplement = async () => {
      setSubmitting(true);
      // const error = await actions.addSupplementAsync(selectedOFH.value);
      let errors = [];

      for (let iter = 0; iter < numberOfSupplementsToAdd; iter++) {
        let error = await actions.addSupplementAsync(selectedOFH.value);

        if (error) {
          errors.push(error);
        }
      }

      setSubmitting(false);

      if (errors.length < 1) {
        handleDialogClose();
      }
    };

    const handleDialogOpen = () => {
      setDialogOpen(true);
    };

    const handleDialogClose = () => {
      setDialogOpen(false);
      !!onClose && onClose();

      setNumberSupplementsToAdd(1);
    };

    return (
      <React.Fragment>
        <MenuItem onClick={handleDialogOpen}>Add Supplement</MenuItem>

        <Dialog
          open={dialogOpen}
          onClose={handleDialogClose}
          aria-labelledby="form-dialog-title"
          classes={{ paperScrollPaper: classes.supplementDialogContent }}
        >
          <DialogTitle id="form-dialog-title" className={classes.dialogTitle}>
            Add Supplement
          </DialogTitle>
          <DialogContent className={classes.supplementDialogContent}>
            <main className={classnames('col-center-top', classes.container)}>
              <label>Choose Supplement:</label>
              <Autocomplete
                options={orderableFormHeaders.map((ofh, ofhIndex) => {
                  return {
                    label: `${ofh.name}`,
                    value: ofh.id,
                  };
                })}
                onChange={setSelectedOFH}
                value={selectedOFH}
                placeholder={'Select...'}
                containerStyles={{ minWidth: 400 }}
              />
              <div style={{ marginTop: 15 }}>
                <label>Choose Amount to Add:</label>
                <ReactSelect
                  defaultValue={{ label: 1, value: 1 }}
                  options={[
                    { label: 1, value: 1 },
                    { label: 2, value: 2 },
                    { label: 3, value: 3 },
                    { label: 4, value: 4 },
                    { label: 5, value: 5 },
                    { label: 6, value: 6 },
                    { label: 7, value: 7 },
                    { label: 8, value: 8 },
                    { label: 9, value: 9 },
                    { label: 10, value: 10 },
                  ]}
                  onChange={ev => setNumberSupplementsToAdd(ev.value)}
                />
              </div>
            </main>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button color="secondary" onClick={handleDialogClose} disabled={submitting || loading}>
              Close
            </Button>
            <Button color="primary" onClick={addSupplement} disabled={submitting || loading}>
              Add Supplement
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  },
);

ReportSupplementForms.propTypes = {};
ReportSupplementForms.defaultProps = {};
